export default "__VITE_ASSET__viBcgYVV__"